import { TaskView } from '@ndvr/customer-api';

import { stripHtmlToText } from 'utils';

export const SORT_COLUMNS = {
    STATUS: 'status',
    TITLE: 'title',
    ASSIGNEE: 'assignee',
    DUE_DATE: 'dueDate',
    TYPE: 'type',
} as const;

export const SORT_DIRECTIONS = {
    ASC: 'asc',
    DESC: 'desc',
} as const;

export type SortColumn = (typeof SORT_COLUMNS)[keyof typeof SORT_COLUMNS];
export type SortDirection = (typeof SORT_DIRECTIONS)[keyof typeof SORT_DIRECTIONS];

type FilterTaskOptions = { searchTerm?: string };

export const filterTasks = (tasks: TaskView[], { searchTerm }: FilterTaskOptions): TaskView[] => {
    const search = searchTerm?.toLowerCase().trim();
    if (!search) {
        return tasks;
    }

    return tasks.filter(
        (task) =>
            task.title?.toLowerCase().includes(search) ||
            stripHtmlToText(task.description || '')
                .toLowerCase()
                .includes(search),
    );
};

type SortTaskOptions = {
    sortColumn: SortColumn;
    sortDirection: SortDirection;
};

const getSortValue = (task: TaskView, sortColumn: SortColumn): string | number => {
    switch (sortColumn) {
        case SORT_COLUMNS.STATUS:
            return task.status?.toLowerCase() || '';
        case SORT_COLUMNS.TITLE:
            return task.title?.toLowerCase() || '';
        case SORT_COLUMNS.ASSIGNEE:
            return task.assigneeName?.toLowerCase() || '';
        case SORT_COLUMNS.DUE_DATE:
            return task.dueDate ? new Date(task.dueDate).getTime() : 0;
        case SORT_COLUMNS.TYPE:
            return task.type?.toLowerCase() || '';
        default:
            return '';
    }
};

export const sortTasks = (tasks: TaskView[], { sortColumn, sortDirection }: SortTaskOptions): TaskView[] => {
    const sortMultiplier = sortDirection === SORT_DIRECTIONS.ASC ? 1 : -1;

    return [...tasks].sort((a, b) => {
        const aValue = getSortValue(a, sortColumn);
        const bValue = getSortValue(b, sortColumn);

        if (aValue < bValue) return -1 * sortMultiplier;
        if (aValue > bValue) return 1 * sortMultiplier;
        return 0;
    });
};
